import { render, staticRenderFns } from "./AutoFilenames.vue?vue&type=template&id=2b672aa5&scoped=true&"
import script from "./AutoFilenames.vue?vue&type=script&lang=js&"
export * from "./AutoFilenames.vue?vue&type=script&lang=js&"
import style0 from "./AutoFilenames.vue?vue&type=style&index=0&id=2b672aa5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b672aa5",
  null
  
)

export default component.exports